import { STATUS_TONES, type ChinaPaymentRecord } from '@mypoz/shared';
import { useTranslation } from '@mypoz/i18n';
import { StatusChip } from '@mypoz/ui';

/**
 * A request's status (MYP-63). The two codes seen live get the app's own words in every language —
 * `INPROGRESS` is 审核中 / Under review, as the vendor and the old website's details page call it
 * — and any other code shows the vendor's label as sent, never a guessed one.
 */
export function RecordStatus({ record }: { record: ChinaPaymentRecord }) {
  const { t } = useTranslation();
  const label =
    record.status === 'review'
      ? t('chinaPayment.records.status.review')
      : record.status === 'cancelled'
        ? t('chinaPayment.records.status.cancelled')
        : (record.statusLabel ?? record.statusCode ?? '—');

  return <StatusChip tone={STATUS_TONES.chinaPayment[record.status]}>{label}</StatusChip>;
}

/** A request's type: the app's own name for the four it knows, the vendor's for any other. */
export function RecordType({ record }: { record: ChinaPaymentRecord }) {
  const { t } = useTranslation();
  return (
    <>
      {record.type
        ? t(`chinaPayment.types.${record.type}`)
        : (record.typeLabel ?? record.typeCode ?? '—')}
    </>
  );
}
